/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win3_TInputs */

const en_wc_vs_win3_t = /** @type {(inputs: Wc_Vs_Win3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real Linux and BSD app`)
};

/**
* | output |
* | --- |
* | "A real Linux and BSD app" |
*
* @param {Wc_Vs_Win3_TInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win3_t = /** @type {((inputs?: Wc_Vs_Win3_TInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win3_TInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win3_t(inputs)
});
export { wc_vs_win3_t as "wc.vs.win3.t" }